import _ from "lodash";
import moment from "moment";

import api from "@/api/cloud";
import { Storage } from "@/utils/storage";
import { get, set } from "../../utils/vuex";

// const storage = Storage.local();
const cache = Storage.local({
	cacheFor: moment.duration(1, "day").asMilliseconds(),
});

const initState = () => ({
	roles: cache.get("roles", {}),
	permissions: cache.get("permissions", {}),
});

export default {
	namespaced: true,
	state: initState(),

	getters: {
		roles: get("roles"),
		permission: get("permissions"),
	},

	mutations: {
		setRoles: set("roles"),

		setRolePermissions: (state, { roleId, permissions }) => {
			state.permissions = {
				...state.permissions,
				[roleId]: permissions || [],
			};
		},
	},

	actions: {
		async initRoles({ commit }) {
			// Get all user roles
			let roles = cache.get("roles");
			if (_.isNil(roles)) {
				roles = await api.getRoles();
				roles = _.keyBy(roles, "id");
				cache.set("roles", roles);
			}
			commit("setRoles", roles);

			// Get permissions for all roles
			await Promise.all(
				_.map(_.keys(roles), roleId => {
					const permissions = cache.get(`role.${roleId}`);
					if (!_.isNil(permissions))
						commit("setRolePermissions", { roleId, permissions });
					else {
						return api.getRolePermissions(roleId).then(permissions => {
							cache.set(`role.${roleId}`, permissions);
							commit("setRolePermissions", {
								roleId,
								permissions,
							});
						});
					}
				})
			);
		},
	},
};
